import { Box, Container, BodyProps } from '@hover/blueprint';
import React, { FunctionComponent, useState } from 'react';
import { ArrowButton, DownloadAppModal } from '@hover/shared-components';
import { HeaderDescription } from '..';

export interface ReadyToSeePossibilitesProps {
  body: string;
  bodyProps?: BodyProps;
  customButton?: React.ReactNode;
}

const ReadyToSeePossibilities: FunctionComponent<
  ReadyToSeePossibilitesProps
> = ({ body, bodyProps, customButton }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <Box w="100%" bg="brandNavy.500" py={1000}>
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Container maxW="3xl" px={{ base: 500, tablet: 0 }} centerContent>
        <HeaderDescription
          px={0}
          heading="Ready to see the possibilities?"
          body={body}
          headingProps={{
            color: 'neutral.0',
            style: { marginBottom: 24, fontWeight: 700 },
          }}
          bodyProps={{
            color: 'neutral.0',
            style: { marginBottom: 40 },
            maxW: { base: '100%', tablet: '80%' },
            ...bodyProps,
          }}
        />
        {customButton || (
          <ArrowButton
            colorScheme="brandNavy"
            variant="inverted"
            onClick={() => toggleModal()}
            w={{ base: '323px', tablet: 'auto' }}
          >
            Try for Free
          </ArrowButton>
        )}
      </Container>
    </Box>
  );
};

export default ReadyToSeePossibilities;
